import { render, staticRenderFns } from "./HeaderV.vue?vue&type=template&id=836e507a&scoped=true&"
import script from "./HeaderV.vue?vue&type=script&lang=js&"
export * from "./HeaderV.vue?vue&type=script&lang=js&"
import style0 from "./HeaderV.vue?vue&type=style&index=0&id=836e507a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836e507a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VIcon,VImg})
